import * as React from 'react';
import { forwardRef, memo } from 'react';

const SvgCalendarIcon = (props, ref) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M4 6h16v14H4V6Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path stroke="currentColor" strokeWidth={1.5} d="M4 6h16v4H4z" />
    <mask id="CalendarIcon_svg__a" fill="#fff">
      <rect x={6} y={12} width={5} height={5} rx={0.5} />
    </mask>
    <rect
      x={6}
      y={12}
      width={5}
      height={5}
      rx={0.5}
      stroke="currentColor"
      strokeWidth={3}
      mask="url(#CalendarIcon_svg__a)"
    />
    <mask id="CalendarIcon_svg__b" fill="#fff">
      <rect x={13} y={12} width={5} height={5} rx={0.5} />
    </mask>
    <rect
      x={13}
      y={12}
      width={5}
      height={5}
      rx={0.5}
      stroke="currentColor"
      strokeWidth={3}
      mask="url(#CalendarIcon_svg__b)"
    />
    <path
      d="M7 4v3M17 4v3"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgCalendarIcon);
const Memo = memo(ForwardRef);
export default Memo;
